var contemporaryChina = '/pegasus/assets/background-patterns/contemporary-china.png';
var escheresque = '/pegasus/assets/background-patterns/escheresque.png';
var grayPlay = '/pegasus/assets/background-patterns/gray-play.png';
var ironGrip = '/pegasus/assets/background-patterns/iron-grip.png';
var lightGray = '/pegasus/assets/background-patterns/light-gray.png';
var mochaGrunge = '/pegasus/assets/background-patterns/mocha-grunge.png';
var shl = '/pegasus/assets/background-patterns/shl.png';
var smallCrackleBright = '/pegasus/assets/background-patterns/small-crackle-bright.png';
var wavesBlue = '/pegasus/assets/background-patterns/subtle-blue-mini-waves.png';
var wavesWhite = '/pegasus/assets/background-patterns/subtle-white-mini-waves.png';
var whiteCarbonFiber = '/pegasus/assets/background-patterns/white-carbon-fiber.png';
var woodenWall = '/pegasus/assets/background-patterns/wooden-wall.png';

(function(){
  var data = {
    dated: null,
    next_page: null,
    page: 1,
    per_page: 100,
    photos: [{
      width: 400,
      height: 400,
      name: null,
      preview: contemporaryChina,
      src: {
        landscape: contemporaryChina,
        large: contemporaryChina,
        medium: contemporaryChina,
        small: contemporaryChina,
        tiny: contemporaryChina
      }
    },{
      width: 460,
      height: 290,
      name: null,
      preview: escheresque,
      src: {
        landscape: escheresque,
        large: escheresque,
        medium: escheresque,
        small: escheresque,
        tiny: escheresque
      }
    },{
      width: 188,
      height: 178,
      name: null,
      preview: grayPlay,
      src: {
        landscape: grayPlay,
        large: grayPlay,
        medium: grayPlay,
        small: grayPlay,
        tiny: grayPlay
      }
    },{
      width: 300,
      height: 301,
      name: null,
      preview: ironGrip,
      src: {
        landscape: ironGrip,
        large: ironGrip,
        medium: ironGrip,
        small: ironGrip,
        tiny: ironGrip
      }
    },{
      width: 301,
      height: 621,
      name: null,
      preview: lightGray,
      src: {
        landscape: lightGray,
        large: lightGray,
        medium: lightGray,
        small: lightGray,
        tiny: lightGray
      }
    },{
      width: 400,
      height: 400,
      name: null,
      preview: mochaGrunge,
      src: {
        landscape: mochaGrunge,
        large: mochaGrunge,
        medium: mochaGrunge,
        small: mochaGrunge,
        tiny: mochaGrunge
      }
    },{
      width: 400,
      height: 400,
      name: null,
      preview: shl,
      src: {
        landscape: shl,
        large: shl,
        medium: shl,
        small: shl,
        tiny: shl
      }
    },{
      width: 420,
      height: 420,
      name: null,
      preview: smallCrackleBright,
      src: {
        landscape: smallCrackleBright,
        large: smallCrackleBright,
        medium: smallCrackleBright,
        small: smallCrackleBright,
        tiny: smallCrackleBright
      }
    },{
      width: 390,
      height: 390,
      name: null,
      preview: wavesBlue,
      src: {
        landscape: wavesBlue,
        large: wavesBlue,
        medium: wavesBlue,
        small: wavesBlue,
        tiny: wavesBlue
      }
    },{
      width: 390,
      height: 390,
      name: null,
      preview: wavesWhite,
      src: {
        landscape: wavesWhite,
        large: wavesWhite,
        medium: wavesWhite,
        small: wavesWhite,
        tiny: wavesWhite
      }
    },{
      width: 400,
      height: 400,
      name: null,
      preview: whiteCarbonFiber,
      src: {
        landscape: whiteCarbonFiber,
        large: whiteCarbonFiber,
        medium: whiteCarbonFiber,
        small: whiteCarbonFiber,
        tiny: whiteCarbonFiber
      }
    },{
      width: 556,
      height: 396,
      name: null,
      preview: woodenWall,
      src: {
        landscape: woodenWall,
        large: woodenWall,
        medium: woodenWall,
        small: woodenWall,
        tiny: woodenWall
      }
    }]
  };

  Pegasus.PatternImagesController = Em.Controller.extend({
    needs: ['imageGallery', 'frameCommManager', 'upload'],
    staggerResults: true,
    breakValue: 3,
    didCompleteRequest: function(data){
      Em.run( this.get('controllers.imageGallery'), 'send', 'didRetrieveImages', data, this);
    },
    useThis: function(view){
      var content = view.get('content');
      var src;

      src = content.src;

      this.set('controllers.upload.dataSrcProxy', src);
      this.get('controllers.upload').send('didReplaceImage');
    },

    sizeContent: function(view){
      var actual = $('<img src="' + view.get('content.src') + '" />');

      if ( !view.get('content.naturalWidth') ) {
        actual.imagesLoaded().
          done(function(img){
            Em.run.next(img, function(){
              try {
                view.set('content.naturalWidth', this.images[0].img.naturalWidth);
                view.set('content.naturalHeight', this.images[0].img.naturalHeight);
              }catch(e){}
            });
          }).
          fail(function(img){
            alert('fail');
          });
      }
    },

    request: function(query, page, count) {
      this.didCompleteRequest(data);
    }
  });
})();
